export default __webpack_public_path__ + "static/media/MainLogo.8708811a.png";